<template>
    <!-- 教练卡片 -->
    <router-link :to="{name:'coachitem',params: { coachId: coachInfo.coachId}}" class="clear mtm coach-card">
        <div class="left coach-card__avatar">
            <avatar-box v-if="coachInfo.avatar" :avatar="coachInfo.avatar" :auth="coachInfo.user.isVip" style="width:100%;height:100%;"></avatar-box>
            <avatar-box v-else-if="coachInfo.avatar==''" :avatar="coachInfo.user.largeAvatar" :auth="coachInfo.user.isVip" style="width:100%;height:100%;"></avatar-box>        
            <avatar-box v-else :avatar="null" style="width:100%;height:100%;"></avatar-box>  <!-- 解决显示图标 -->
        </div>
        <div class="coach-ard__info">
          <div class="coach-card__info--uname">
            <div class="left fs3 c4">{{ coachInfo.realName }}</div>
            <div class="fs2 c9">&nbsp;/ 累计上课{{ coachInfo.lessons?coachInfo.lessons:0 }}课时</div>
          </div>
          <div class="coach-card__info--auth fs2 c9 mtn">
            <i class="iconfont">&#xe630; 新锐台球认证教练</i> 
          </div>
        </div>
      </router-link>
</template>
<script>
import AvatarBox from '@/components/AvatarBox';
export default {
    name: 'CoachCard',
    components:{
        AvatarBox
    },
    props:{
        coachInfo:{  //教练信息
            type: Object,
            required: true
        },
    },
    data(){
        return {
            
        }
    },
    created(){
        // console.log(this.coachInfo.avatar)
    }
}
</script>
<style lang="less" scoped>
// 教练信息模块
.coach-card {
    display: block;
    &__avatar {
        width: 0.5rem;
        height: 0.5rem;        
        margin-right: 0.15rem;
        overflow: hidden;
    }
    &__info {
        &--auth {
            & > .iconfont {
                font-size: 0.14rem;
                color: #FFA800;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CoachCard.vue